import { useMutation } from "@tanstack/react-query";
import { axios } from "../../../shared/lib/axios";
import _cookies from "../../../shared/utils/_cookies";

export const uploadVideoToYoutube = async (data) => {
  const body = new FormData();
  const fileBlob = new Blob([data.file], { type: data.file?.type });
  body.append("data", fileBlob);
  body.append(
    "title",
    `ALUNOID: ${_cookies.getItem("auth").user.alunoid} - Postagemid: ${
      data.postId
    } - ${data.title}"`
  );

  const res = await axios.middleware.post(
    "https://cadernovirtual-n8n.e2vaxu.easypanel.host/webhook-test/UploadYoutubeMultiple",
    body
  );
  return res;
};

export const useUploadVideoToYoutube = ({ config } = {}) => {
  return useMutation({ ...config, mutationFn: uploadVideoToYoutube });
};
